import React, { useEffect, useState } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { getContentfulClient } from '../../lib/roptoClientLibrary';

import './privacy-policy.scss';

const PrivacyPolicy = () => {
  const [privacyPolicy, setPrivacyPolicy] = useState();

  const contentfulClientOpts = {
    accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
    space: process.env.CONTENTFUL_SPACE_ID,
  };

  const contentfulPPClient = getContentfulClient(
    contentfulClientOpts.accessToken,
    contentfulClientOpts.space,
  );


  useEffect(() => {
    async function fetchPP() {
      const response = await contentfulPPClient.getEntry(
        process.env.CONTENTFUL_PP_ID,
      );
      setPrivacyPolicy(response);
    }
    fetchPP();
  }, []);

  return (
    <div className="privacy-policy">
      <div className="privacy-policy__container">
        { privacyPolicy
          && <h1 className="privacy-policy__title">{privacyPolicy.fields.title}</h1>
        }
        <div className="privacy-policy__content">
          { privacyPolicy && documentToReactComponents(privacyPolicy.fields.body) }
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
